<template>
    <section>
      <div class="card">
        <div class="container-card">
          <span><b>Claimed: </b>{{claim.addPlayerName}} to {{claim.addPosition}}</span>
          <br>
          <span><b>Dropped: </b>{{claim.dropPlayerName}}</span>
        </div>
        <div class="mdl-card__actions mdl-card--border">
          <button id="cancelClaimButton" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" v-on:click="clicked">
            Cancel Claim
          </button>
        </div>
      </div>
    </section>
</template>

<script>
import { db } from '../db'
import firebase from "firebase";

export default {
  data() {
    return { 
      
    }
  },
  props: {
     claim: {
      type: Object,
      required: true,
      default: null
     }
  },
  components: {
  },
  methods: {
    clicked() {
      this.$emit('clicked');
    }
  },
  watch: {
  },
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/WavierClaim.vue